import { gql } from '@apollo/client';

export const COURSE_SEMESTERS_FOR_SELECT = gql`
  query course_semesters_for_select($where: course_semester_bool_exp) {
    course_semester(where: $where) {
      id
      semester
    }
  }
`;
